"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useWindowDimensionsContext = require("ecosystem-marketplace-core/hooks/useWindowDimensionsContext");

var POINTS = {
  xs: 0,
  sm: 544,
  md: 768,
  lg: 992,
  xl: 1200
};

var useWindowWidth = function useWindowWidth(breakpoints) {
  var _useWindowDimensionsC = (0, _useWindowDimensionsContext.useWindowDimensionsContext)(),
      windowWidth = _useWindowDimensionsC.width;

  return breakpoints ? Object.keys(breakpoints).reduce(function (result, size) {
    return windowWidth >= POINTS[size] ? result || breakpoints[size] : result;
  }, false) : windowWidth;
};

var _default = useWindowWidth;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/utils/hooks/useWindowWidth.js
// module id = 698
// module chunks = 209 210 211 212